import React from 'react'
import { KPICardStyled, KPIIcon, KPIContent } from '../styled/Operations.styled'

interface KPICardProps {
  icon: React.ReactNode
  value: number
  label: string
  color: string
}

export const KPICard: React.FC<KPICardProps> = ({ icon, value, label, color }) => {
  return (
    <KPICardStyled>
      <KPIIcon color={color}>{icon}</KPIIcon>
      <KPIContent>
        <span className="kpi-value">{value}</span>
        <span className="kpi-label">{label}</span>
      </KPIContent>
    </KPICardStyled>
  )
}
